// this directive scrolls the element in question to top, if it gets the focus.
// use this to avoid having the submit button hidden by the keyboard on mobile
//
// Note: not used at the moment, since it does not seem to be helpful

import {AfterViewInit, Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[scrollTopOnFocus]',
  standalone: false
})

export class ScrollTopOnFocusDirective {

  @Input() scrollTopOnFocus: string;

  constructor(private el: ElementRef) {}

  @HostListener('focus') onMouseEnter() {
    if (this.scrollTopOnFocus) {
      const target = document.querySelector(this.scrollTopOnFocus);
      if (target) {
        target.scrollIntoView(true);
      }
    } else {
      this.el.nativeElement.scrollIntoView(true);
    }
  }
}
